export const getFields = () => {
  const formFieldsConfiguration: Array<{
    label: string;
    name: 'newPassword' | 'confirmPassword';
    placeholder: string;
    required: boolean;
    defaultValue?: any;
    type: string;
  }> = [
    {
      name: 'newPassword',
      label: 'New Password',
      placeholder: 'Enter your new password',
      required: true,
      type: 'password',
    },
    {
      name: 'confirmPassword',
      placeholder: 'Confirm your new password',
      label: 'Confirm Password',
      required: true,
      type: 'password',
    },
  ];
  return formFieldsConfiguration;
};
